<div class="form-wrapper" (click)="onOutsideClick($event)">
  <div class="form-popup">
    <right-panel-header
      [headerTitle]="'Taxonomy Test'"
      [buttonText]="isCreatingTest() ? 'Creating...' : 'Run Test'"
      [disabled]="!isFormValid() || isCreatingTest()"
      [showDeleteButton]="false"
      (onApply)="onConfirm()"
      (onClose)="onCancel()">
    </right-panel-header>

    <div class="form-body">
      <div class="form-section-container">
        <!-- Test Label Field -->
        <div class="field-container">
          <label for="testLabel">Test Label <span class="required-star">*</span></label>
          <input
            type="text"
            id="testLabel"
            class="custom-input"
            placeholder="Enter Label"
            maxlength="100"
            [value]="testLabel()"
            [disabled]="isCreatingTest()"
            (input)="onTestLabelChange($any($event.target).value)">
        </div>

        <div class="section-divider"></div>

        <!-- Taxonomy Selection Field -->
        <div class="field-container">
          <label for="taxonomy">Taxonomy <span class="required-star">*</span></label>
          <form-select-dropdown
            dropdownId="taxonomy-dropdown"
            [contentList]="taxonomyOptions"
            [selectedValue]="selectedTaxonomy()"
            [placeholder]="isLoadingTaxonomies() ? 'Loading...' : 'Select'"
            [disabled]="isLoadingTaxonomies() || isCreatingTest()"
            (onItemSelect)="onTaxonomySelect($event)">
          </form-select-dropdown>
        </div>

        <!-- Version Selection Field -->
        <div class="field-container">
          <label for="version">Version <span class="required-star">*</span></label>
          <app-version-dropdown
            dropdownId="version-dropdown"
            [contentList]="versionOptions"
            [selectedValue]="selectedVersion()"
            [placeholder]="isLoadingVersions() ? 'Loading...' : 'Select'"
            [disabled]="isLoadingVersions() || isCreatingTest() || !selectedTaxonomy()"
            (onItemSelect)="onVersionSelect($event)">
          </app-version-dropdown>
        </div>

        <div class="section-divider"></div>

        <!-- Dataset Selection Field -->
        <div class="field-container">
          <label for="dataset">Dataset <span class="required-star">*</span></label>
          <app-dataset-dropdown
            dropdownId="dataset-dropdown"
            [contentList]="datasetOptions"
            [selectedValue]="selectedDataset()"
            [placeholder]="'Select'"
            [disabled]="isCreatingTest()"
            [isLoading]="isLoadingDatasets()"
            (onItemSelect)="onDatasetSelect($event)">
          </app-dataset-dropdown>
        </div>

        <!-- Instructions Section -->
        <div class="instructions-section">

          <div class="instruction-header">
          <div class="instructions-title">
            <strong>Don't have a sample dataset?</strong>
          </div>
          <div class="instructions-subtitle">
            Follow the steps below to create a new data sample.
          </div>
          </div>

          <div class="steps-list">
            <div class="step-item">
              <span class="step-number">1</span>
              <span class="step-text">Go to data view in insights dashboard</span>
            </div>
            <div class="step-item">
              <span class="step-number">2</span>
              <span class="step-text">Select records you want to include.</span>
            </div>
            <div class="step-item">
              <span class="step-number">3</span>
              <span class="step-text">Create a new data sample from your selection.</span>
            </div>
            <div class="step-item">
              <span class="step-number">4</span>
              <span class="step-text">Use it in the playground to run a new test.</span>
            </div>
          </div>

          <button class="btn-go-to-data-view" (click)="goToDataView()">
            Go to Data View
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
